import { DayHeaderContentArg } from '@fullcalendar/core';
import { format } from 'date-fns';
import React from 'react';
import { useToday } from 'shared/contexts/today';

import * as Styled from './date-header.style';

export const DateHeader: React.FC<DayHeaderContentArg> = ({ date }) => {
  const today = useToday();
  // fullcalendar gives utc date, so we need to add the timezone offset to display the correct date for the user
  const _date = new Date(date.getTime() + date.getTimezoneOffset() * 60_000);

  // Month headers are weekday columns, so highlight the column whose weekday
  // matches today (FullCalendar's own isToday is unreliable for dow headers).
  const isToday = _date.getDay() === today.getDay();

  return (
    <Styled.DateHeaderContainer $isToday={isToday}>
      {format(_date, 'EEE')}
    </Styled.DateHeaderContainer>
  );
};
